import { Modal, Form, Input, Button, Col, Row } from 'antd';
import Logo from '../../Logo/Logo';
import LoginFormCode from '../LoginFormCode';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MaskedInput from 'antd-mask-input';

interface Props {
  loading? : boolean,
  email? : string,
  visible: boolean,
  showCodeField? : boolean,
  toggleLogin: boolean,
  onRegister: (values: any) => void,
  onCancel: () => void,
  onSuccessLogin: (value: any) => void
}

const RegisterModal = (Props: Props) => {
  const [form] = Form.useForm();
  const [toggle, setToggle] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setToggle(Props.toggleLogin);
  }, [Props.toggleLogin])

  const handleOk = () => {
      form.validateFields().then((values: any) => {
        Props.onRegister(values);
      })
  };

  return (
    <Modal
      visible={Props.visible}
      title=""
      okText={Props.toggleLogin ? 'Iniciar' : "Registrarme"}
      cancelText="Cancelar"
      footer={null}
      onCancel={Props.onCancel}
      onOk={handleOk}
    >
      <Row justify={"center"} align={"middle"}>
        <Col>
          <Logo size={"100%"} />
          <h2 style={{ textAlign: 'center' }}>Iniciar sesión</h2>
        </Col>
      </Row>
      {toggle ? (
        <>
          <LoginFormCode email={Props.email} showCodeField={Props.showCodeField} onSuccessLogin={Props.onSuccessLogin} />
          <p className='flex-centered'>No tienes cuenta aún?<a href="#" onClick={($event) => {
            $event.preventDefault();
            setToggle(!toggle);
          }} style={{ marginLeft: 10, color: '#f37221' }}>{toggle ? 'Registrarse' : 'Entrar'}</a></p>
        </>
      ) : (
        <>
          <Form
            form={form}
            layout="vertical"
            onFinish={async (values: any) => {
              form.validateFields().then((values: any) => {
                  Props.onRegister(values);
              })
            }}
            name="register"
          >
            <Form.Item
              label="Nombres"
              name="first_name"
              rules={[
                { type: 'string', required: true },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Apellidos"
              name="last_name"
              rules={[
                { type: 'string', required: true },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { type: 'email', required: true },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Confirmar Email"
              name="confirmEmail"
              rules={[
                { required: true },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('email') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject('Los emails no coinciden');
                  },
                }),
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Télefono"
              name="phone"
              rules={[
                { type: 'string', required: true },
              ]}
            >
            <MaskedInput
                  mask={
                    '+57(000)000-0000'
                  }
              />
            </Form.Item>
            <Form.Item wrapperCol={{ span: 24 }}>
                <Button
                  loading={Props.loading}
                  type="primary"
                  size={"large"}
                  block
                  htmlType="submit"
                >
                  Crear cuenta
                </Button>
              </Form.Item>
          </Form >
          <p className='flex-centered'>Ya tienes una cuenta ?<a href="#" onClick={($event) => {
            $event.preventDefault();
            setToggle(!toggle);
          }} style={{ marginLeft: 10, color: '#f37221' }}>{'Entrar'}</a></p>
          <a href="#/" className="flex-centered" style={{ marginLeft: 10, color: '#f37221', fontWeight: 500 }}>
              Privacidad de datos
          </a>
        </>
      )}
    </Modal >
  )
}
  ;


export default RegisterModal;